import { type SVGProps } from 'react';

export function WifiLow(props: Readonly<SVGProps<SVGSVGElement>>) {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...props}>
            <path
                d='M10 15.4166H10.0098'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M7.0835 12.9166C8.4407 11.5594 11.5592 11.5594 12.9165 12.9166'
                stroke='currentColor'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M4.1665 10.4167C6.5236 8.0596 13.4762 8.0596 15.8332 10.4167'
                stroke='currentColor'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
                opacity='0.3'
            />
            <path
                d='M1.25 7.91677C4.79167 4.37511 15.2083 4.37511 18.75 7.91677'
                stroke='currentColor'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
                opacity='0.3'
            />
        </svg>
    );
}
